"use strict";
export function draw_ai_response_tab(ai_responses) {
	if (!Array.isArray(ai_responses)) {
		console.error("Error: ai_responses is not an array or is null");
		return;
	}

	// Clear the AI response container first
	$('#ai_response').empty();

	ai_responses.forEach(function(item) {
		// Check if 'responses' is present and is an array
		if (!Array.isArray(item.responses)) {
			console.error("Error: item.responses is not an array or is null");
			return;
		}

		// For each response in item.responses
		item.responses.forEach(function(response) {
			// Check if the response was flagged as too long
			if (response.content === 'too_long') {
				const html = `
                    <div class="ai-response">
                        <div class="header-block">${response.added} | ${response.tokens} | ${response.title}</div>
                        <pre class="language-json"><code class="language-json">Response too long to display</code></pre>
                    </div>
                `;
				$('#ai_response').append(html);
				return; // Skip further processing
			}

			// Parse the content (assumed to be JSON)
			let parsedContent;
			try {
				parsedContent = JSON.parse(response.content);
			} catch (error) {
				console.error("Failed to parse JSON content:", error);
				return;
			}

			// Format the JSON response (pretty-print)
			const formattedJSON = JSON.stringify(parsedContent, null, 2);
			const escapedJSON = formattedJSON
				.replace(/&/g, '&amp;')
				.replace(/</g, '&lt;')
				.replace(/>/g, '&gt;')
				.replace(/"/g, '&quot;');

			// Create the HTML structure for the code block
			const html = `
                <div class="ai-response">
                    <div class="header-block">${response.added} | ${response.tokens} | ${response.title}</div>
                    <pre class="language-json"><code class="language-json">${escapedJSON}</code></pre>
                </div>
            `;

			// Inject the formatted HTML into the target div
			$('#ai_response').append(html);
		});
	});

	// Apply Prism.js syntax highlighting
	Prism.highlightAll();
}
